import { render, staticRenderFns } from "./CustomerProposalLinkModal.vue?vue&type=template&id=ff641e18&scoped=true"
import script from "./CustomerProposalLinkModal.vue?vue&type=script&lang=js"
export * from "./CustomerProposalLinkModal.vue?vue&type=script&lang=js"
import style0 from "./CustomerProposalLinkModal.vue?vue&type=style&index=0&id=ff641e18&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff641e18",
  null
  
)

export default component.exports